import React from 'react';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';

export function Copyright(props: any) {
    return (
        <Typography variant="body2" align="center" color="#1d1d1d" {...props}>
            {'Copyright © '}
            <Link color="inherit" href="https://www.comware.com.co/">
                ComWare
            </Link>{' '}
            {new Date().getFullYear()}
            {'.'}
        </Typography>
    );
}
